import React, { Component } from 'react'
import Radium from 'radium'
//import ReactSVG from 'react-svg'

//import TELink from './../../../component/Navigation/TELink'

import images from './../../../config/images'

import styles from './styles'

class Footer extends Component {
	render() {
		return (
			<div style={styles.container}>
				<div style={styles.titleContainer}>
					<h5 style={styles.companyName}>Rebel Analytics</h5>
					<p style={styles.companyCopy}>Think Differently About Performance Marketing</p>
				</div>
				<ul style={styles.navUl}>
					<li style={styles.navLi}>
						<a href="http://rebel-travel.com/about/" style={styles.link} key='about'>About</a>
					</li>
					<li style={styles.navLi}>
						<a href="http://rebel-travel.com/partners/" style={styles.link} key='partners'>Partners</a>
					</li>
					<li style={styles.navLi}>
						<a href="http://rebel-travel.com/blogs/" style={styles.link} key='blog'>Blogs</a>
					</li>
					<li style={styles.navLi}>
						<a href="http://rebel-travel.com/contact-us/" style={styles.link} key='contact'>Contact Us</a>
					</li>
				</ul>
				<div style={styles.subfooter}>
					<a href='tel:16306399426' style={styles.footerLink} key='tel'>(630) 639-9426</a>
					<img src={images.logoGray} alt='logo' title='Rebel Analytics' style={styles.logo}/>
				</div>
			</div>
		)
	}
}

Footer.propTypes = {}

Footer.defaultProps = {}

export default Radium(Footer)



// WEBPACK FOOTER //
// ./src/layout/Front/Footer/Footer.js